// extracted by mini-css-extract-plugin
export var featuredLabel = "feature-marker-module--featured-label--c0aea";